export default __webpack_public_path__ + "static/media/echo.5bda9a3a.PNG";